Monitoring.Views ||= {}

class Monitoring.Views.RuleListView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/rule_list"]

  events:
    'click .edit-rule': 'onClickEdit'
    'click .delete-rule': 'onClickDelete'

  initialize: (@options = {}) ->
    @rules             = @options.rules
    @availableTopics   = @options.availableTopics
    @availableTags     = @options.availableTags
    @availableGroups   = @options.availableGroups
    @availableSubtypes = @options.availableSubtypes
    @availableUserProfileTags = @options.availableUserProfileTags
    @currentUser       = @options.currentUser
    @availableSentiments = @options.availableSentiments
    @availableModerationDecision = @options.availableModerationDecision

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    ruleId = $(evt.currentTarget).data('id')
    rule_to_edit = @rules.get(ruleId)
    @trigger('edit', rule_to_edit)

  onClickDelete: (evt) ->
    swal({
      title: I18n.t('monitoring.rules.confirmation.are_you_sure')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.rules.confirmation.confirm')
      cancelButtonText: I18n.t('monitoring.rules.confirmation.cancel')
      closeOnConfirm: true
    }, =>
      ruleId = $(evt.currentTarget).data('id')
      ruleToDelete = @rules.get(ruleId)
      ruleToDelete.destroy(
        success: (response) =>
          console.log("Deleted rule #{ruleToDelete.get('name')}")
          @rules.remove(ruleToDelete)
          @render()
        error: (response) =>
          console.log("Error deleting rule #{ruleToDelete.get('name')}")
      )
    )

# TODO Refactor: Hacer modelo social_content_conditions.js
# Duplicado con Monitoring.Views.ReviewQueueDefinitionListView
  getScConditionsAsText: (rule) ->
    _.filter([
      @getTopicsString(rule),
      @getIncludedTagsString(rule),
      @getExcludedTagsString(rule),
      @getIncludedGroupsString(rule),
      @getExcludedGroupsString(rule),
      @getSubtypesString(rule),
      @getOwnershipString(rule),
      @getAuthorsString(rule),
      @getExcludedAuthorsString(rule),
      @getLocationsString(rule),
      @getMentionsString(rule),
      @getMinFollowersString(rule),
      @getNewsSourcesString(rule),
      @getSentimentsString(rule),
      @getModerationStatusString(rule),
      @getKeywordsString(rule)
    ], (str) -> str != "").join('<br>')

  getKeywordsString: (rule) ->
    # TODO: This is to avoid conflicts when doing a cherry-pick. Delete this method when the real 'getKeywordsString' exists
    return ''

  getTopicsString: (rule) ->
    if rule.get('social_content_condition').topics.length > 0
      topicNames = _.map(rule.get('social_content_condition').topics, (id) =>
        topic = _.find(@availableTopics, (topic) -> topic.id == parseInt(id))
        topic && topic.name
      )
      "#{I18n.t('monitoring.rules.fields.topics')}: #{topicNames.join(', ')}"
    else
      ""

  getIncludedTagsString: (rule) ->
    @includedTagsStringFor(rule.get('social_content_condition'))

  includedTagsStringFor: (conditions) ->
    filter = conditions.intelligent_filter.intelligent_tags
    tags = (filter.main_tags || []).concat((filter.secondary_tags || []))
    @tagsString(tags, 'monitoring.rules.fields.tags.included')

  getExcludedTagsString: (rule) ->
    @excludedTagsStringFor(rule.get('social_content_condition'))

  excludedTagsStringFor: (conditions) ->
    tags = conditions.intelligent_filter.intelligent_tags.excluded_tags || []
    @tagsString(tags, 'monitoring.rules.fields.tags.excluded')

  tagsString: (tagIds, translation) ->
    if tagIds.length > 0
      tagDescriptions = _.map(_.uniq(tagIds), (tagId) =>
        matchingTag = _.find(@availableTags, (tag) -> tag.code.toString() == tagId.toString())
        "'#{if matchingTag then matchingTag.description else tagId}'"
      )

      "#{I18n.t(translation)}: #{tagDescriptions.join(', ')}"
    else
      ''

  getIncludedGroupsString: (rule) ->
    @includedGroupsStringFor(rule.get('social_content_condition'))

  includedGroupsStringFor: (conditions) ->
    filter = conditions.intelligent_filter.intelligent_groups
    groupIds = (filter.main_groups || []).concat((filter.secondary_groups || []))
    @groupsString(groupIds, 'monitoring.rules.fields.groups.included')

  getExcludedGroupsString: (rule) ->
    @excludedGroupsStringFor(rule.get('social_content_condition'))

  excludedGroupsStringFor: (conditions) ->
    groupIds = conditions.intelligent_filter.intelligent_groups.excluded_groups || []
    @groupsString(groupIds, 'monitoring.rules.fields.groups.excluded')

  groupsString: (groupIds, translation) ->
    if groupIds.length > 0
      groupDescriptions = _.map(_.uniq(groupIds), (groupId) =>
        matchingGroup = _.find(@availableGroups, (group) -> group.code.toString() == groupId.toString())
        "'#{if matchingGroup then matchingGroup.description else groupId}'"
      )

      "#{I18n.t(translation)}: #{groupDescriptions.join(', ')}"
    else
      ''

  getSentimentsString: (rule) ->
    rule_sentiments = rule.get('social_content_condition').sentiments
    if rule_sentiments.length > 0
      translated_rule_sentiments = _.map(rule_sentiments, (s) ->
        I18n.t('monitoring.rules.sentiments.' + s)
      )
      "#{I18n.t('monitoring.rules.fields.sentiments')}: #{translated_rule_sentiments.join(', ')}"
    else
      ""

  getSubtypesString: (rule) ->
    if rule.get('social_content_condition').subtypes.length > 0
      subtypeNames = _.map(rule.get('social_content_condition').subtypes, (code) =>
        _.find(@availableSubtypes, (subtype) -> subtype.code == code).name
      )
      "#{I18n.t('monitoring.rules.fields.types')}: #{subtypeNames.join(', ')}"
    else
      ""

  getModerationStatusString: (rule) ->
    moderation_statuses = rule.get('social_content_condition').moderation_statuses
    if moderation_statuses.length > 0
      translated_moderation_statuses = _.map(moderation_statuses, (s) ->
        I18n.t('monitoring.rules.fields.' + s)
      )
      "#{I18n.t('monitoring.rules.fields.moderation')}: #{translated_moderation_statuses.join(', ')}"
    else
      ""

  getOwnershipString: (rule) ->
    if rule.get('social_content_condition').ownership == 'own-content'
      I18n.t('monitoring.rules.fields.only_own_content')
    else if rule.get('social_content_condition').ownership == 'not-own-content'
      I18n.t('monitoring.rules.fields.exclude_own_content')
    else
      ""

  getAuthorsString: (rule) ->
    if rule.get('social_content_condition').authors.length > 0
      "#{I18n.t('monitoring.rules.fields.authors')}: #{rule.get('social_content_condition').authors.join(', ')}"
    else
      ""

  getExcludedAuthorsString: (rule) ->
    if rule.get('social_content_condition').excluded_authors.length > 0
      "#{I18n.t('monitoring.rules.fields.excluded_authors')}: #{rule.get('social_content_condition').excluded_authors.join(', ')}"
    else
      ""

  getLocationsString: (rule) ->
    if rule.get('social_content_condition').locations.length > 0
      "#{I18n.t('monitoring.rules.fields.locations')}: #{rule.get('social_content_condition').locations.join(', ')}"
    else
      ""

  getMentionsString: (rule) ->
    if rule.get('social_content_condition').mentions.length > 0
      "#{I18n.t('monitoring.rules.fields.mentions')}: #{rule.get('social_content_condition').mentions.join(', ')}"
    else
      ""

  getMinFollowersString: (rule) ->
    if rule.get('social_content_condition').min_followers
      "#{I18n.t('monitoring.rules.fields.minimum_followers')}: #{rule.get('social_content_condition').min_followers}"
    else
      ""

  getNewsSourcesString: (rule) ->
    if rule.get('social_content_condition').news_sources.length > 0
      "#{I18n.t('monitoring.rules.fields.news_sources')}: #{rule.get('social_content_condition').news_sources.join(', ')}"
    else
      ""

  getKeywordsString: (rule) ->
    keywords = rule.get('social_content_condition').keywords
    unless _.isEmpty(keywords)
      keyword_string = _.filter([
        @getKeywordsGroupString("primary_keywords", keywords),
        @getKeywordsGroupString("secondary_keywords", keywords),
        @getKeywordsGroupString("excluded_keywords", keywords)
      ], (str) -> str != "").join('<br>')
      keyword_string
    else
      ""

  getKeywordsGroupString: (keyword_type, keywords) ->
    list = keywords[keyword_type]
    logic = keywords["#{keyword_type}_logic"]
    keyword_name = I18n.t("monitoring.tagging_rules.fields.#{keyword_type}")
    if list.length > 0
      "#{keyword_name} (#{@getKeywordsLogicString(logic)}): #{list.join(", ")}"
    else
      ""

  getKeywordsLogicString: (logic) ->
    if logic == "OR"
      "#{I18n.t('monitoring.dashboard.filters.keywords.any')}"
    else
      "#{I18n.t('monitoring.dashboard.filters.keywords.all')}"


  getActionsAsText: (rule) ->
    actions_string = _.filter([
        @getTagToUserProfileAction(rule.get('actions'), 'add_tag_to_user_profile'),
        @getTagToSocialContentAction(rule.get('actions'), 'add_tag_to_social_content'),
        @getTagToSocialContentAction(rule.get('actions'), 'remove_tag_from_social_content'),
        @getRemoveAllTagsFromSocialContentAction(rule.get('actions'), 'remove_all_tags_from_social_content'),
        @getGroupToSocialContentAction(rule.get('actions'), 'add_label_to_social_content'),
        @getGroupToSocialContentAction(rule.get('actions'), 'remove_label_from_social_content'),
        @getSentimentToSocialContentAction(rule.get('actions'), 'add_sentiment_to_social_content'),
        @getModerationDecisionToSocialContentAction(rule.get('actions'), 'add_moderation_decision_to_social_content')
      ], (str) -> str != "").join('<br>')
    actions_string

  getTagToUserProfileAction: (actions, action_type) ->
    action = actions[action_type]
    if action && action.length > 0
      tagId = action[0].user_profile_tag.id
      tagDescription = _.find(@availableUserProfileTags, (tag) -> tag.id == parseInt(tagId)).description
      @actionDescription(action_type, tagDescription)
    else
      ""

  getSentimentToSocialContentAction: (actions, action_type) ->
    sentimentCode = actions[action_type]
    if sentimentCode
      sentimentDescription = _.find(@availableSentiments, (sentiment) -> sentiment.code == sentimentCode).name
      @actionDescription(action_type, sentimentDescription)
    else
      ""

  getTagToSocialContentAction: (actions, action_type) ->
    tagId = actions[action_type]
    if tagId
      tag = _.find(@availableTags, (tag) -> tag.code == tagId)
      tag ||= { description: tagId }
      tagDescription = tag.description
      @actionDescription(action_type, tagDescription)
    else
      ""

  getRemoveAllTagsFromSocialContentAction: (actions, action_type) ->
    removeAllTags = actions[action_type]
    if removeAllTags
      I18n.t('monitoring.rules.actions.remove_all_tags_from_social_content')
    else
      ""

  getGroupToSocialContentAction: (actions, action_type) ->
    groupId = actions[action_type]
    if groupId
      group = _.find(@availableGroups, (group) -> group.name == groupId)
      group ||= { name: groupId }
      groupDescription = group.name
      inherit = actions['inherit_group_from_parent']
      inherit_text = if inherit then ". #{I18n.t('monitoring.rules.actions.inherit_group_from_parent')}" else ''
      @actionDescription(action_type, groupDescription) + inherit_text
    else
      ""

  getModerationDecisionToSocialContentAction: (actions, action_type) ->
    moderationDecision = actions[action_type]
    if moderationDecision
      description = _.find(@availableModerationDecision, (e) -> e == moderationDecision)
      @actionDescription(action_type, description)
    else
      ""

  actionDescription: (action_type, descr) ->
    prefix = I18n.t("monitoring.rules.actions.#{action_type}.prefix")
    suffix = I18n.t("monitoring.rules.actions.#{action_type}.suffix")
    "#{prefix} '#{descr}' #{suffix}"
